import { inject, InjectionToken } from "@angular/core";
import { ProductService } from "src/app/services/product.service";
import { SoftwareProduct } from "src/app/support/product";

export const ONBOARDING_ENABLED = new InjectionToken<boolean>(
  "onboarding_enabled",
  {
    providedIn: "root",
    factory: () => {
      const currentProduct = inject(ProductService).getCurrentProduct();
      return currentProduct === SoftwareProduct.PLATFORM;
    }
  }
);
